import OffsetWellPickerV5 from '../OffsetWellPickerV5';

// Show new V5 instead of V4 on all envs.
const OffsetWellPickerV4 = OffsetWellPickerV5;

export default OffsetWellPickerV4;
